import React from 'react';
import Styles from './EmprestimoGarantiaCarroCondicoes.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import clsx from 'clsx';
import ModalSeguros from '@/components/molecules/ModalSeguros';
function EmprestimoGarantiaCarroCondicoes() {
  return (
    <>
      <section id="emprestimo-garantia-condicoes">
        <ContainerHome24>
          <div className="condicoes-contain">
            <img
              src="assets/banco-do-auto25/Carros.svg"
              alt="carros de empréstimo com garantia de veículo santander"
              className="condicoes-contain-img"
            />
            <div className="condicoes-contain-conteudo">
              <h2 className="condicoes-contain-titulo">Condições gerais de contratação</h2>
              <p className="condicoes-contain-subtitulo">Empréstimo com Garantia de Veículo</p>
              <div className="condicoes-contain-cards">
                <div className="cards-condicao">
                  <a
                    href="pdf/emprestimo-garantia-carro/condicoes-gerais-SIM-santander.pdf"
                    target="_blank"
                    className="card-condicao"
                  >
                    <img src="assets/seguro-auto-25/ic_file_pdf.svg" alt="" />
                    <div className="condicao-textos">
                      <h3 className="condicao-textos-titulo">Contratação online</h3>
                      {/* <p className="condicao-textos-descricao">Vigência: de 27/10/2023 em diante</p> */}
                    </div>
                  </a>
                  <a
                    href="pdf/emprestimo-garantia-carro/condicoes-gerais-SIM-santander.pdf"
                    target="_blank"
                    className="card-condicao"
                  >
                    <img src="assets/seguro-auto-25/ic_file_pdf.svg" alt="" />
                    <div className="condicao-textos">
                      <h3 className="condicao-textos-titulo">
                        Contratação Assistida (Loja / Agência)
                      </h3>
                      {/* <p className="condicao-textos-descricao">Vigência: de 27/10/2023 em diante</p> */}
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </ContainerHome24>
      </section>
      <style jsx>{Styles}</style>
    </>
  );
}

export default EmprestimoGarantiaCarroCondicoes;
